import {persianToEnglishDigits} from "../persianToEnglish/convertEnglish";

export const formatNumber = (input: string) => {
    const numbersOnly = persianToEnglishDigits(input).replace(/\D/g, "");
    return numbersOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};